export default "__VITE_ASSET__DW_x6PTg__"